import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { App } from '../models/appication/app';
import { Application } from '../models/appication/application';


@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  public url: string
  public apps:App [];

  constructor(
    private _http: HttpClient,

  ) { 
    this.url= environment.url;
  }

  getMyApps(next_token):Observable<any>{
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    if (next_token!=undefined){
      return this._http.get<any>(`${this.url}/applications/my_applications?next_token=${next_token}`, { headers });
    }else{
      return this._http.get<any>(`${this.url}/applications/my_applications`, { headers });
    }
    
  }

  getDashboardApps(next_token):Observable<any>{
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    if (next_token!=undefined){
      return this._http.get<any>(`${this.url}/applications/dashboard?next_token=${next_token}`, { headers });
    }else{
      return this._http.get<any>(`${this.url}/applications/dashboard`, { headers });
    }
  }

  getApplicationById(id:string):Observable<Application>{
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get<Application>(this.url + '/applications?id='+id, { headers });
  }

  postApplication(application):Observable<any>{
    const parans = JSON.stringify(application);
    const headers = new HttpHeaders();
    return this._http.post(this.url+'/applications', parans, {headers});
  }

  updateApplication(draw):Observable<any>{
    const parans = JSON.stringify(draw);
    const headers = new HttpHeaders();
    return this._http.put(this.url+'/applications', parans, {headers});
  }
}
